import { Round } from "./Round";
import { ROUND_HASH } from "../constants";
import { useFetchAllProgressByRound } from "../Hooks/useFetchAllProgressByRound";
import { checkActiveRound } from "../helper";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";

export const Rounds = ({
  shoppingToolsFilters,
}: {
  shoppingToolsFilters: FilterValue[];
}) => {
  const { data: countValues, isFetching } = useFetchAllProgressByRound();
  return (
    <>
      <Round
        round={ROUND_HASH.MORNING?.round ?? ""}
        title={ROUND_HASH.MORNING?.transKey ?? ""}
        roundCounts={countValues?.morning}
        loading={isFetching}
        activeRound={checkActiveRound(ROUND_HASH.MORNING?.round ?? "")}
        shoppingToolsFilters={shoppingToolsFilters}
      />
      <Round
        round={ROUND_HASH.MIDDAY?.round ?? ""}
        title={ROUND_HASH.MIDDAY?.transKey ?? ""}
        roundCounts={countValues?.midday}
        loading={isFetching}
        activeRound={checkActiveRound(ROUND_HASH.MIDDAY?.round ?? "")}
        shoppingToolsFilters={shoppingToolsFilters}
      />
      <Round
        round={ROUND_HASH.AFTERNOON?.round ?? ""}
        title={ROUND_HASH.AFTERNOON?.transKey ?? ""}
        roundCounts={countValues?.afternoon}
        loading={isFetching}
        activeRound={checkActiveRound(ROUND_HASH.AFTERNOON?.round ?? "")}
        shoppingToolsFilters={shoppingToolsFilters}
      />
    </>
  );
};
